import React from 'react';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {withSystem, Atom} from '@packages/systems/wfdl';

import {TText, TRecord, TListOfElement} from '@packages/systems/wfdl-ast';
import {List} from 'immutable';
import {getChildren} from '@packages/utilities/data-utils';

const maybeAddAlign = (align: any) => (classes: List<string>) =>
  align ? classes.push('w-richtext-align-' + align) : classes;

const maybeAddType = (type: any) => (classes: List<string>) =>
  type ? classes.push('w-richtext-figure-type-' + type) : classes;

const Figure = Atom.createRender(
  ({attributes, classes, data, generateAttributes, renderChild}) => {
    const figureClasses = classes
      // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
      .update(maybeAddAlign(data.figure?.align))
      // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
      .update(maybeAddType(data.figure?.type));
    return (
      <figure {...generateAttributes(attributes, figureClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </figure>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Figure',
  showEmpty: true,
  render: Figure,
  fields: {
    children: TListOfElement,
    figure: withSystem(
      {private: true},
      TRecord({
        type: TText,
        align: TText,
      })
    ),
  },
});

export default config;
